/*****************************************************************************/
/*  File Name: header.js                                                     */
/*  Date:      Nov 25, 2021                                                  */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the header block that will be on the top of the pages */
/*                                                                           */
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import { useUserContext } from '../../context/userContext';
//import Button from '@mui/material/Button';
import NavigationMenu from '../Navigation';
import styles from './styles/header.module.scss';
import { useROIContext } from '../../context/roiContext';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import DescriptionIcon from '@mui/icons-material/Description';
import { CSVLink, CSVDownload } from 'react-csv';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import * as MODE from '../../constants/modes';

function Header({ t }) {
  //Load all of the default component varaibles

  const { user } = useUserContext();
  const { roiLoading, roi, roiID, roiSaving, setForceROISave, generateROIpdf, roiMode, pdfModule } = useROIContext();
  //console.log('this is my chart data -----> ', chartData);
  //console.log('this is my if statement ----> ', !roiLoading ? (roi.id ? 'we have an roi loaded' : 'No roi id') : 'My roi is loading');
  //console.log('this is  my roi saving ????? ----> ', roiSaving);
  //console.log('this is my roi ---->', roi, PDFroi);

  //console.log('this is my pdf loading ---', pdfLoading);

  return (
    <Grid container alignItems='center' className={styles.header}>
      <div className={styles.identity}>
        <NavigationMenu user={user} t={t} />
        <div className={styles.title}>Solta ROI Calculator</div>
      </div>

      {!roiLoading && (roiID || roi.id) ? (
        <div className={styles.actions}>
          {roiMode === MODE.capital || roiMode === MODE.consumer || roiMode === MODE.upgrade ? (
            pdfModule ? (
              <IconButton>
                <CircularProgress className={styles.buttons} />
              </IconButton>
            ) : (
              <Tooltip title='Save PDF'>
                <IconButton onClick={() => generateROIpdf({ ...roi, id: roi.id ?? roiID })}>
                  <PictureAsPdfIcon className={styles.buttons} />
                </IconButton>
              </Tooltip>
            )
          ) : null}

          {roiSaving ? (
            <IconButton>
              <CircularProgress className={styles.buttons} />
            </IconButton>
          ) : (
            <Tooltip title='Save ROI'>
              <IconButton onClick={() => setForceROISave(true)}>
                <SaveIcon className={styles.buttons} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ) : null}
    </Grid>

    
  );
}

export default withTranslation()(Header);
